import React, { useCallback, useEffect, useRef, useState } from "react";
import GrupoVerificacionService from "../../services/ListaVerificacion/GrupoVerificacionService";
import { IComboBox, IComboBoxOption } from "@fluentui/react";

interface IFilterCombo {
  search: string;
}

export const useComboGrupoVerificacion = () => {
  const [filter, setFilter] = useState<IFilterCombo>({ search: "" });
  const [dataComboGrupoVeri, setDataComboGrupoVeri] = useState<IComboBoxOption[]>([]);

  const comboBoxRefGrupoVeri = useRef<IComboBox>(null);
  const _openOptionGrupoVeri = useCallback(
    () => comboBoxRefGrupoVeri.current?.focus(true),
    []
  );
  const onClickComboGrupoVeri = () => comboBoxRefGrupoVeri.current?.focus(true);

  const _onkeyUpSearchGrupoVeri = (event: React.KeyboardEvent<IComboBox>) => {
    if (event.code === "Escape") {
      comboBoxRefGrupoVeri.current?.focus(false);
      setFilter({ search: "" });
    } else {
      _openOptionGrupoVeri();
      let { value } = event?.target as HTMLInputElement;
      setFilter({ search: value });
    }
  };

  const postComboGrupoVerificacion = () => {
    GrupoVerificacionService.ListarCombomGrupoVerificacion(filter).then(
      (res) => {
        if (res.status === 200) {
          setDataComboGrupoVeri(res.data);
        }
      }
    );
  };

  useEffect(() => {
    postComboGrupoVerificacion();
  }, [filter]);
  return {
    dataComboGrupoVeri,
    onClickComboGrupoVeri,
    _onkeyUpSearchGrupoVeri,
    comboBoxRefGrupoVeri,
  };
};
